import type { RouteObject } from 'react-router';

import routes from '@/assets/constants/routes-no';
import { competitionWinnersQuery } from '@/lib/api/queries';
import { simpleRace, smartLazy } from '@/lib/router-utils';
import { queryClient } from '@/queryClient';

export const summer2024Routes: RouteObject[] = [
  {
    path: routes.SUMMER_JUNE_2024_COMPETITION,
    lazy: () => smartLazy(import('./LandingPage/LandingPageJune')),
  },
  {
    path: routes.SUMMER_JUNE_2024_COMPETITION_TERMS,
    lazy: () => smartLazy(import('./TermsJune')),
  },
  {
    path: routes.SUMMER_JULY_2024_COMPETITION,
    loader: () =>
      simpleRace([queryClient.prefetchQuery(competitionWinnersQuery())]),
    lazy: () => smartLazy(import('./LandingPage/LandingPageJuly')),
  },
  {
    path: routes.SUMMER_JULY_2024_COMPETITION_TERMS,
    lazy: () => smartLazy(import('./TermsJuly')),
  },
];
